import React from 'react';

const CSS = () => {
  return (
    <div className="content-page">
      <h1>CSS Tutorial</h1>
      
      <div className="tutorial-section">
        <h2>What is CSS?</h2>
        <p>CSS (Cascading Style Sheets) is used to style and layout web pages — for example, to alter the font, color, size, and spacing of your content, split it into multiple columns, or add animations and other decorative features.</p>
      </div>

      <div className="example">
        <h3>Example</h3>
        <div className="code-container">
          <pre>{`body {
  background-color: lightblue;
}

h1 {
  color: white;
  text-align: center;
}

p {
  font-family: verdana;
  font-size: 20px;
}`}</pre>
          <button className="try-it-btn">Try it Yourself »</button>
        </div>
      </div>

      <div className="tutorial-navigation">
        <button className="btn-prev">❮ Previous</button>
        <button className="btn-next">Next ❯</button>
      </div>
    </div>
  );
};

export default CSS;
